<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="1350px"
  >
    <template v-slot:activator="{ on }">
      <v-btn  
        v-if="![100,502].includes(task.task_status.id)"
        icon
        v-on="on"
      >
        <v-icon
          color="primary"
        >
          mdi-information-outline
        </v-icon>
      </v-btn>

      <v-btn
        v-else
        icon
        v-on="on"
      >
        <v-icon
          color="primary"
        >
          mdi-checkbox-blank-circle-outline
        </v-icon>
      </v-btn>
    </template>

    <material-card
      :offset="10"
      :full-width="true"
      color="green"
      title="Task"
      text="Complete Task"
      class="mb-0"
    >
      <v-container v-if="dialog">
        <v-row>
          <v-col
            cols="7"
            class="pl-5 pr-5"
          >
            <div class="align-header-switch">
              <span class="font-weight-bold header">
                Task
              </span>
              <v-spacer />
              <v-switch
                v-model="approvalTab"
                inset
                class="pt-0 mt-0 margin-auto"
                label="Action Tab"
              />
            </div>
         
            <div
              :id="task.task_scroll_id"
              class="px-4 pr-6 overflow"
            >
              <v-row>
                <div
                  class="task-content content-pre-line"
                  v-html="formatContent(task.task.content)"
                />
              </v-row>

              <v-row class="mt-2">
                <div class="task-details">
                  <v-row>
                    <v-col
                      cols="6"
                      class="pt-0"
                    >
                      <span class="font-weight-bold"> Task Priority:</span> {{ task.task.priority.name }}
                    </v-col>
                    <v-col
                      cols="6"
                      class="pt-0"
                    >
                      <span class="font-weight-bold"> Task Category: </span>{{ task.task.task_category.name }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="6"
                      class="py-0"
                    >
                      <span class="font-weight-bold"> Task Owner:</span> {{ task.task.owner.person.name }}
                    </v-col>
                    <v-col
                      cols="6"
                      class="py-0"
                    >
                      <span class="font-weight-bold"> Status:</span>
                      <span
                        :class="{ 
                          'warning--text': task.task_status.id === 100,
                          'green--text': task.task_status.id === 199,
                          'black--text': task.task_status.id === 200,
                          'red--text':task.task_status.id === 501
                        }"
                      > {{ task.task_status.name }}</span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <span class="font-weight-bold">Created Date:</span> {{ $moment(task.task.created_at).format('DD MMM YYYY') }}
                    </v-col>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <span class="font-weight-bold">Due Date:</span> {{ $moment(task.task.due_date).format('DD MMM YYYY') }}
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <span class="font-weight-bold">Assignee(s):</span> {{ task.assignee_names }}
                    </v-col>
                    <v-col
                      cols="6"
                      class="pb-0"
                    >
                      <span class="font-weight-bold"> Viewer(s):</span> {{ task.viewer_names }}
                    </v-col>
                  </v-row>
                </div>
              </v-row>

              <v-row>
                <v-col
                  cols="12"
                  class="font-weight-bold px-0 pb-0"
                >
                  ATTACHMENTS

                  <helper-auto-upload-file-input
                    v-model="file"
                    :max-size-in-mb="2" 
                    :max-number="5"
                    :multiple="true"
                    data-vv-name="files"
                    field-name="files"
                    accept-type=".xlsx,.pdf,.docx,.jpeg,.jpg,.png"
                    extension="ext:xlsx,pdf,docx,jpeg,jpg,png"    
                    @input="uploadDocuments"            
                  >
                    <span 
                      slot="activator"
                      class="mb-2"
                    >   
                      <v-btn                    
                        :disabled="progressing"
                        class="mx-2"    
                        icon
                        color="primary"
                      >
                        <v-icon>
                          mdi-cloud-upload
                        </v-icon>
                      </v-btn>
                    </span>
                  </helper-auto-upload-file-input>
                </v-col>
              
                <v-col
                  cols="12"
                  class="pa-0"
                >
                  <span class="red--text text--lighten-1">{{ errors.first('files') }}</span>
                  <span> 
                    {{ file ? '' : 'No file chosen (.pdf, .docx, .xslsx, .jpeg, .jpg, .png only)' }}
                  </span>
                  <div
                    v-if="file"
                    class="mt-4"
                  >
                    <p
                      v-for="selectedFile in file.selectedFiles"
                      :key="selectedFile.name"
                      class="mb-0"
                    >
                      <v-progress-circular
                        indeterminate
                        color="primary"
                        :size="15"
                      />  <span class="font-weight-bold pl-2">{{ selectedFile.name }}</span>
                    </p>
                  </div>
                </v-col>
              </v-row>

              <div class="px-3">
                <v-row>
                  <v-col
                    v-for="document in task.task.documents"
                    :key="document.id"
                    class="px-0 pb-0"
                    cols="2"
                  >
                    <v-card
                      class="mx-2 mb-2"
                      height="120"
                      width="100"
                      target="_blank"
                      :href="document.file_url"
                    >
                      <div class="file-display">
                        <v-icon
                          v-if="document.file_url.split('.').pop()==='pdf'"
                          color="red"
                          x-large
                          class="margin-auto"
                          v-text="'mdi-file-pdf'"
                        />

                        <v-icon
                          v-else-if="document.file_url.split('.').pop()==='xlsx'"
                          color="green"
                          x-large
                          class="margin-auto"
                          v-text="'mdi-file-excel'"
                        />

                        <v-icon
                          v-else-if="document.file_url.split('.').pop()==='docx'"
                          color="blue"
                          x-large
                          class="margin-auto"
                          v-text="'mdi-file-document'"
                        />

                        <v-img
                          v-else-if="['png','jpeg','jpg'].includes(document.file_url.split('.').pop())"
                          width="80"
                          height="80"
                          :src="document.file_url"
                        />
                      </div>

                      <v-tooltip bottom>
                        <template v-slot:activator="{ on: tooltip }">
                          <p
                            class="text-center font-weight-bold long-and-truncated px-1"
                            v-on="{ ...tooltip }"
                          >
                            {{ document.file_name }}
                          </p> 
                        </template>
                        <span>{{ document.file_name }}</span>
                      </v-tooltip>
                    </v-card>
                  </v-col>
                </v-row>
              </div>
            </div>
          </v-col>
    
          <v-col
            v-show="approvalTab"
            cols="5"
            class="px-4 divider"
          >
            <h4 class="font-weight-bold">
              Approval History
            </h4>
            <div
              v-if="task.task.approval_request.approvals.length>0"
              :id="task.approval_scroll_id" 
              :class=" [199].includes(task.task_status.id)? 'approval-comment-content-no-remark':'approval-comment-content' "
            >
              <v-row
                v-for="approval in task.task.approval_request.approvals "
                :key="approval.id"
                no-gutters
              >
                <v-col cols="12">
                  <v-list
                  
                    three-line
                    class="py-0"
                  >
                    <v-list-item>
                      <v-list-item-avatar size="55">
                        <v-img :src="approval.approver.thumbnail_url" />
                      </v-list-item-avatar>

                      <v-list-item-content>
                        <v-list-item-title class="body-1">
                          {{ approval.created_by }}
                        </v-list-item-title>

                        <v-list-item-subtitle class="body-2">
                          {{ $moment(approval.created_at).format('D MMMM YYYY') }}
                        </v-list-item-subtitle>
                        <v-list-item-subtitle style=" -webkit-line-clamp: unset !important;">
                          Remark: {{ approval.remark }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-col>
              </v-row>
            </div>
            <div
              v-else
              :class=" [199].includes(task.task_status.id)? 'approval-comment-content-no-remark':'approval-comment-content' " 
            >
              No Approval History
            </div>
      
            <div v-if="[100,502].includes(task.task_status.id)">
              <v-row class="horizontal-divider">
                <v-col cols="11">
                  <v-textarea
                    v-model="remark"
                    v-validate="'required|max:255'"
                    label="Remark"
                    :rows="2"
                    auto-grow
                    outlined
                    class="mt-2"
                    data-vv-name="remark"
                    :error-messages="errors.collect('remark')"
                  />
                </v-col>

                <v-col
                  cols="1"
                  class="margin-auto"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn
                        icon
                        color="success"
                        v-on="{ ...tooltip }"
                        @click="submitForm"
                      >
                        <v-icon> mdi-checkbox-marked-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>Mark as Complete</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
          </v-col>
  
          <v-col
            v-show="!approvalTab"
            cols="5"
            class="px-4 divider"
          >
            <h4 class="font-weight-bold">
              Comments
            </h4>
            
            <div
              v-if="task.task.task_comments.length>0"
              :id="task.comment_scroll_id"
              class="approval-comment-content"
            >
              <v-row
                v-for="comment in task.task.task_comments "
                :key="comment.id"
                no-gutters
                class="my-2 mx-4"
              >
                <div
                  v-if="task.assignee_uid === comment.commentator_uid"
                  class="pa-2 comment-box-left"
                >
                  <v-col
                    cols="12"
                    class="justify-content pa-0 content-pre-line"
                    v-html="formatContent(comment.comment)"
                  />
                  <v-col
                    cols="12"
                    class="align-right pa-0"
                  >
                    <i>
                      {{ $moment(comment.created_at).format('DD MMM YYYY') }} - <span class="font-weight-bold"> {{ comment.employee.person.name }} </span>
                    </i>
                  </v-col>
                </div>
                <div
                  v-else
                  class="pa-2 comment-box-right"
                >
                  <v-col
                    cols="12"
                    class="justify-content pa-0 content-pre-line"
                    v-html="formatContent(comment.comment)"
                  />
                  <v-col
                    cols="12"
                    class="align-left pa-0"
                  >
                    <i>
                      <span class="font-weight-bold"> {{ comment.employee.person.name }} </span> - {{ $moment(comment.created_at).format('DD MMM YYYY') }}
                    </i>
                  </v-col>
                </div>
              </v-row>
            </div>
            <div
              v-else
              class="approval-comment-content"
            >
              No Comments
            </div>
    
            <div>
              <v-row class="horizontal-divider">
                <v-col cols="11">
                  <v-textarea
                    v-model="comment"
                    v-validate="'required|max:255'"
                    label="Comment"
                    :rows="2"
                    :disabled="sent"
                    :loading="commentLoading"
                    auto-grow
                    outlined
                    class="mt-2"
                    data-vv-name="comment"
                    :error-messages="errors.collect('comment')"
                  />
                </v-col>
            
                <v-col
                  cols="1"
                  class="margin-auto"
                >
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on: tooltip }">
                      <v-btn
                        icon
                        color="info"
                        :disabled="sent"
                        @click="submitComments"
                        v-on="{ ...tooltip }"
                      >
                        <v-icon>mdi-send</v-icon>
                      </v-btn>
                    </template>
                    <span>Send</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </div>
          </v-col>
        </v-row>
      </v-container>

      <v-card-actions>  
        <v-spacer />
        <v-btn
          :disabled="progressing"
          text
          @click="dialog = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </material-card>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      HelperAutoUploadFileInput: () => import('@/components/helper/AutoUploadFileInput'),
    },
    inject: ['$validator'],
    props: {
      task: {
        type: Object,
        default: null,
      },

    },
    data () {
      return {
        dialog: false,
        progressing: false,
        remark: null,
        content: null,
        file: null,
        sent: false,
        commentLoading: false,
        comment: null,
        approvalTab: false,
      }
    },

    watch: {
      dialog (value) {
        if (value) {
          this.$nextTick(() => {
            this.scrollBottom()
          })
        }
      },

      approvalTab (value) {
        if (this.dialog) {
          this.$nextTick(() => {
            this.scrollBottom()
          })
        }
      },
    },

    methods: {
      scrollBottom () {
        // comment section
        if (this.task.task.task_comments.length > 0) {
          let comment = document.getElementById(this.task.comment_scroll_id)
          comment.scrollTop = comment.scrollHeight
        }

        // approval history
        if (this.task.task.approval_request.approvals.length > 0) {
          let approval = document.getElementById(this.task.approval_scroll_id)
          approval.scrollTop = approval.scrollHeight
        }

        // task
        if (this.task.task_status.id === 200) {
          let task = document.getElementById(this.task.task_scroll_id)
          task.scrollTop = task.scrollHeight
        }
      },

      formatContent (content) {
        if (content.includes('http')) {
          let urlRegex = /(https?:\/\/[^\s]+)/g
          return content.replace(urlRegex, function (url) {
            return '<a href="' + url + '" target="_blank">' + url + '</a>'
          })  
        }
     
        return content
      },

      uploadDocuments () {
        if (this.file) {
          this.$api.taskDocuments().create(this.task.task.id, this.prepareDocumentFormData())
            .then((res) => {
              this.$snack({ message: 'Document(s) uploaded succesfully' })
              this.$emit('updated')
              this.file = null
            }).catch(e => {
              this.file = null
            })
        }
      },
      
      prepareDocumentFormData () {
        if (this.file) {
          return this.file.formData
        }

        let formData = new FormData()

        return formData
      },

      submitComments () {
        this.$validator.validate('comment', this.comment)
          .then(result => {
            if (!result) return false

            this.sent = true
            this.commentLoading = true
            this.$api.taskComments().create(this.task.task.id, this.prepareCommentData())
              .then((res) => {
                this.resetComment()
                this.$emit('updated')
                this.sent = false
                this.commentLoading = false
              })
          })
      },

      submitForm () {
        this.$validator.validate('remark', this.remark)
          .then(result => {
            if (!result) return

            this.progressing = true

            this.$api.assigneeTasks().complete(this.task.task.id, this.prepareFormData())
              .then((res) => {
                if (res.status === 200) {
                  this.$emit('updated')             
                  this.$snack({ message: 'Task has been mark as completed' })
                  this.resetComment()
                  this.dialog = false    
                }
              }).catch(() => {
                this.$snack({ 
                  color: 'error',
                  message: 'Failed to mark task as completed', 
                })
              }).then(() => {
                this.progressing = false
              })
          })
      },

      prepareFormData () {
        return {
          remark: this.remark,
        }
      },

      prepareCommentData () {
        return {
          comment: this.comment,
        }
      },

      resetForm () {
        this.$validator.reset()
        this.remark = null
        this.file = null
        this.comment = null
        this.approvalTab = false
      },
      resetComment () {
        this.$validator.reset()
        this.comment = null
        this.remark = null
      },
    },
  }
</script>

<style scoped>
.long-and-truncated {
  display: inline;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  word-wrap: break-word;/* Important for long words! */
}

.task-details{
  background-color:#fbfbfb;
  border-radius:5px;
  padding:10px;
  width:100%
}

.task-content{
  border:1px solid #e6e6e6;
  border-radius:5px;
  padding:10px;
  min-height:100px;
  width:100%;
  text-align: justify;
  text-justify: inter-word;
  font-size:15px;
  color:#343434
}

.divider{
  border-left:1px solid #e6e6e6
}

.margin-auto{
    margin:auto
}

.file-display{
  min-height:70px;
  text-align:center;
  display:flex
}

.horizontal-divider{
  border-top:1px solid #e6e6e6;
  margin-top:20px
}

.header{
  font-size:18px !important
}

.align-header-switch{
  display: flex;
  margin-top: 12px;
  height: 40px;
}

.approval-comment-content{
  max-height:360px;
  overflow-y:auto;
  min-height:360px
}

.approval-comment-content-no-remark{
  max-height:500px;
  overflow-y:auto;
  min-height:500px
}

.comment-box-left{
  border:1px solid #e6e6e6;
  border-radius:5px;
  width:436px;
  margin-left:30px;
}

.comment-box-right{
  border:1px solid #e6e6e6;
  border-radius:5px;
  width:436px;
  margin-right:30px;
}

.justify-content{
  text-align: justify;
  text-justify: inter-word;
}

.align-right{
  text-align:right
}

.overflow{
  height:500px;
  overflow-y: auto;
}

::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  box-shadow: inset 0 0 2px #e6e6e6; 
  border-radius: 10px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: grey; 
  border-radius: 10px;
  height: 2px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555; 
}

.content-pre-line{
  white-space: pre-line;
}
</style>
